module.exports = __webpack_public_path__ + "img/dtWpEluc.a9bb81fc.svg";